"use strict";require("core-js/modules/es.array.some");exports.__esModule = true;exports.isArr = isArr;exports.isF = isF;exports.isNum = isNum;exports.isNull = isNull;exports.isUndef = isUndef;exports.isNil = isNil;exports.isStr = isStr;exports.isNonEmptyStr = isNonEmptyStr;exports.isBool = isBool;exports.isObj = isObj;exports.isBlob = isBlob;exports.isFile = isFile;exports.isSVG = isSVG;exports.isNullSome = isNullSome;exports.isEl = isEl;exports.isPromise = isPromise;

var _obj = require("./obj");



/**
                              * @namespace is
                              */



/**
                                  * isArr
                                  *
                                  *
                                  * @param {mixed} any
                                  * @returns {boolean}
                                  * @memberof is
                                  */
function isArr(any) {
  return Array.isArray(any);
}

/**
   * isF
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isF(any) {
  return typeof any === 'function';
}

/**
   * isNum
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isNum(any) {
  // eslint-disable-next-line no-restricted-globals
  return typeof any === 'number' && !isNaN(any);
}

/**
   * isNull
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isNull(any) {
  return any === null;
}

/**
   * isUndef
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isUndef(any) {
  return any === undefined;
}

/**
   * isNil
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isNil(any) {
  return isNull(any) || isUndef(any);
}

/**
   * isStr
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isStr(any) {
  return typeof any === 'string';
}

/**
   * isNonEmptyStr
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isNonEmptyStr(any) {
  return typeof any === 'string' && any.length !== 0;
}


/**
   * isBool
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isBool(any) {
  return typeof any === 'boolean';
}

/**
   * isObj
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isObj(any) {
  return (0, _obj.getFullType)(any) === '[object Object]';
}

/**
   * isBlob
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isBlob(any) {
  return (0, _obj.getFullType)(any) === '[object Blob]';
}

/**
   * isFile
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isFile(any) {
  return (0, _obj.getFullType)(any) === '[object File]';
}



/**
   * isSVG
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isSVG(any) {
  return any instanceof window.SVGElement;
}


/**
   * Проверяет все ли переданные аргументы являются null
   *
   *
   * @param {...*} args
   * @returns {boolean}
   * @memberof is
   */
function isNullSome() {for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
  return args.some(function (arg) {return isNull(arg);});
}





/**
   * isEl
   *
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isEl(any) {
  return any instanceof HTMLElement || isSVG(any);
}



/**
   * isPromise
   *
   * @param {mixed} any
   * @returns {boolean}
   * @memberof is
   */
function isPromise(any) {
  return (0, _obj.getFullType)(any) === '[object Promise]';
}


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/is.js
// module id = 1
// module chunks = 0